// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scrollbar-primary::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }
  .scrollbar-primary::-webkit-scrollbar-track {
    background: transparent;
  }
  
  .scrollbar-red::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }
  .scrollbar-red::-webkit-scrollbar-track {
    background: transparent;
  }
  
  .scrollbar-primary-opaq::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }
  .scrollbar-primary-opaq::-webkit-scrollbar-track {
    background: transparent;
  }
  .scrollbar-primary-opaq::-webkit-scrollbar-thumb {
    background: #5568FE80;
  }
  
  .scrollbar-primary-transparent::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }
  .scrollbar-primary-transparent::-webkit-scrollbar-track {
    background: transparent;
  }
  .scrollbar-primary-transparent::-webkit-scrollbar-thumb {
    background: transparent;
  }
  
  .scrollbar-primary-opaq-gray::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }
  .scrollbar-primary-opaq-gray::-webkit-scrollbar-track {
    background: transparent;
  }
  .scrollbar-primary-opaq-gray::-webkit-scrollbar-thumb {
    background: #ffffff1a;
  }
  
  .scrollbar-primary::-webkit-scrollbar-thumb {
    background: #5568FE;
  }
  .scrollbar-primary::-webkit-scrollbar-thumb:hover {
    background: #5568FE;
  }
  
  .scrollbar-red::-webkit-scrollbar-thumb {
    background: #e03b3480;
  }
  .scrollbar-red::-webkit-scrollbar-thumb:hover {
    background: #e03b3480;
  }
  .scrollbar-primary-opc::-webkit-scrollbar-thumb:hover {
    background: #5568FE;
  }
  .scrollbar-secondary::-webkit-scrollbar {
    width: 3px;
  }
  .scrollbar-secondary::-webkit-scrollbar-track {
    background: #212032;
  }
  .scrollbar-secondary::-webkit-scrollbar-thumb {
    background: #5568FE;
  }
  .scrollbar-secondary::-webkit-scrollbar-thumb:hover {
    background: #5568FE;
  }
  
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  `, "",{"version":3,"sources":["webpack://./src/scrollbar.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB","sourcesContent":[".scrollbar-primary::-webkit-scrollbar {\n    width: 3px;\n    height: 3px;\n  }\n  .scrollbar-primary::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  \n  .scrollbar-red::-webkit-scrollbar {\n    width: 3px;\n    height: 3px;\n  }\n  .scrollbar-red::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  \n  .scrollbar-primary-opaq::-webkit-scrollbar {\n    width: 3px;\n    height: 3px;\n  }\n  .scrollbar-primary-opaq::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  .scrollbar-primary-opaq::-webkit-scrollbar-thumb {\n    background: #5568FE80;\n  }\n  \n  .scrollbar-primary-transparent::-webkit-scrollbar {\n    width: 3px;\n    height: 3px;\n  }\n  .scrollbar-primary-transparent::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  .scrollbar-primary-transparent::-webkit-scrollbar-thumb {\n    background: transparent;\n  }\n  \n  .scrollbar-primary-opaq-gray::-webkit-scrollbar {\n    width: 3px;\n    height: 3px;\n  }\n  .scrollbar-primary-opaq-gray::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  .scrollbar-primary-opaq-gray::-webkit-scrollbar-thumb {\n    background: #ffffff1a;\n  }\n  \n  .scrollbar-primary::-webkit-scrollbar-thumb {\n    background: #5568FE;\n  }\n  .scrollbar-primary::-webkit-scrollbar-thumb:hover {\n    background: #5568FE;\n  }\n  \n  .scrollbar-red::-webkit-scrollbar-thumb {\n    background: #e03b3480;\n  }\n  .scrollbar-red::-webkit-scrollbar-thumb:hover {\n    background: #e03b3480;\n  }\n  .scrollbar-primary-opc::-webkit-scrollbar-thumb:hover {\n    background: #5568FE;\n  }\n  .scrollbar-secondary::-webkit-scrollbar {\n    width: 3px;\n  }\n  .scrollbar-secondary::-webkit-scrollbar-track {\n    background: #212032;\n  }\n  .scrollbar-secondary::-webkit-scrollbar-thumb {\n    background: #5568FE;\n  }\n  .scrollbar-secondary::-webkit-scrollbar-thumb:hover {\n    background: #5568FE;\n  }\n  \n  ::-webkit-scrollbar-corner {\n    background: transparent;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
